'use client'

import { useContext } from 'react'
import { AnnounceContext } from './context'

export function useAnnounce() {
  return { announce: useContext(AnnounceContext) }
}
